










exports.default =
  components:
    flowForm: require './form.vue'

  data: ->
    flow: new Flow
    type_of_action: this.$t('general.actions.new')

  methods:
    loadFlow: ->
      Loader.on()
      new FlowsResource().get(@loadFlowSuccess, @unknownError, id: @$route.params.id)

    loadFlowSuccess: (resource) ->
      Loader.off()
      @type_of_action = this.$t('flows.actions.newFromLib')
      @flow = @buildFlow(resource.flow, true)

    buildFlow: (flow, copying = false) ->
      @type_of_action = this.$t('flows.actions.retryAfterError') if flow.job_status != null

      actions = for loaded_action in flow.actions
        @buildAction(loaded_action, copying)

      new Flow(
        id: if flow.isWithError() then flow.id else null
        name: flow.name
        emails_per_day: flow.emails_per_day
        weekdays_to_send: flow.weekdays_to_send
        actions: actions
        semi_automatic: flow.semi_automatic
        job_status: flow.job_status
        triggers: flow.triggers.map (trigger) ->
          id = if flow.isWithError() then trigger.id else null
          Object.assign(trigger, { id: id, action_value: null, action_metadata: [] })
        lost_reason_id: flow.lost_reason_id
        bcc: flow.bcc
        delay_before_finishing_contact_amount: flow.delay_before_finishing_contact_amount
        delay_before_finishing_contact_unit: flow.delay_before_finishing_contact_unit
        category_id: flow.category_id
        with_task_timer: flow.with_task_timer
      )

    buildAction: (loaded_action, copying = false) ->
      flow = new FlowAction(
        step: loaded_action.step
        name: loaded_action.name
        send_at: loaded_action.send_at
        template_id: loaded_action.template_id
        delay_after_previous_step_amount: loaded_action.delay_after_previous_step_amount
        delay_after_previous_step_unit: loaded_action.delay_after_previous_step_unit
        send_as_reply: loaded_action.send_as_reply
        immediately: loaded_action.immediately
        type: loaded_action.type
        manual_task_parameters: loaded_action.manual_task_parameters
        undefined_time: loaded_action.undefined_time,
      )
      flow.template = Object.assign({}, loaded_action.template)
      flow.template_copied_from_id = loaded_action.original_template_id if copying
      flow

    setFlow: ->
      if @$route.params.id
        @loadFlow()
      else
        @flow = new Flow weekdays_to_send: [1, 2, 3, 4, 5]

  created: ->
    EventsBus.$on 'ActionPicker:Created', @setFlow

  beforeDestroy: ->
    EventsBus.$off 'ActionPicker:Created', @setFlow




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flows/new.vue